import { FaLightbulb, FaCertificate, FaHandshake, FaSchool,FaCode, FaSuitcase} from 'react-icons/fa';
import { FaUpwork } from 'react-icons/fa6';

export const JOURNEY_DATA = [
    {
        year: "2019",
        title: "Discovered My Passion",
        text: "Started college with a focus on computer science. Fell in love with coding and problem-solving, and knew I wanted to build a career in tech.",
        icon: <FaLightbulb />,
        color: "#f59e0b" 
    },
    {
        year: "2020-2022",
        title: "Internships & Real-World Experience",
        text: "Gained hands-on experience through internships at various tech companies, working on real projects and collaborating with experienced professionals.",
        icon: <FaCode />,
        color: "#3b82f6" 
    },
    {
        year: "2023-2024",
        title: "Graduated & Entered the Workforce",
        text: "Relocated to the US and earned my degree in computer science. ",
        icon: <FaCertificate />,
        color: "#10b981" 
    },
    {
        year: "2024-2025",
        title: "Self-Employed Software Engineer & IT Consultant",
        text: "Started working as a software engineer and IT consultant, helping businesses leverage technology to solve problems and achieve their goals.",
        icon: <FaHandshake />,
        color: "#da9ff0" 
    },
    {
        year: "2025-2026",
        title: "Went Back to College for Graduate Studies",
        text: "Pursued graduate studies in Software Engineering to deepen my knowledge and expand my skill set, while continuing to consult and work on projects in the tech industry.",
        icon: <FaSchool />,
        color: "#65823e" 
    },
    {
        year: "2025-2026",
        title: "Web Development & Consulting for Nonprofits",
        text: "Started working with nonprofits as a graduate research assistant to build websites and digital solutions that help them achieve their missions more effectively.",
        icon: <FaUpwork />,
        color: "#9db826" 
    },
    {
        year: "2026",
        title: "Looking for New Opportunities",
        text: "Currently seeking new opportunities to apply my skills and experience in software development and IT consulting, and to continue growing as a technology professional.",
        icon: <FaSuitcase />,
        color: "#65823e" 
    }
    
];